import { render } from "./HeroiconsOutlineBadgeCheck.vue?vue&type=template&id=e4647894"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineBadgeCheck.vue"]])

export default __exports__